// extracted by mini-css-extract-plugin
export default {"css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root":"ConfigInputs_css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root__ESEJp","modalPopup":"ConfigInputs_modalPopup__Bymwr"};